import React from "react";
import "./deleteModal.css";

export default function DeleteReminderModal({
  isOpen,
  onClose,
  onConfirm,
  isDeleting,
}) {
  if (!isOpen) return null;

  return (
    <div className="delete-reminder-overlay">
      <div className="delete-reminder-modal">

        <div className="modal-icon confirm-icon">
          <svg
            width="80"
            height="80"
            viewBox="0 0 28 28"
            fill="none"
          >
            <path
              d="M19.5,16 C22.5375661,16 25,18.4624339 25,21.5 C25,24.5375661 22.5375661,27 19.5,27 C16.4624339,27 14,24.5375661 14,21.5 C14,18.4624339 16.4624339,16 19.5,16 Z M14,2 C16.1421954,2 17.8910789,3.68396847 17.9951047,5.80035966 L18,6 L23,6 C23.5522847,6 24,6.44771525 24,7 C24,7.51283584 23.6139598,7.93550716 23.1166211,7.99327227 L23,8 L22.151,8 L21.5567191,15.3321126 C20.910333,15.1166725 20.2187917,15 19.5,15 C15.9101491,15 13,17.9101491 13,21.5 C13,23.2469007 13.6891263,24.8328473 14.8103588,26.0008195 L10.7666018,26 C8.81304683,26 7.18674613,24.5002245 7.02886788,22.5530595 L5.848,8 L5,8 C4.48716416,8 4.06449284,7.61395981 4.00672773,7.11662113 L4,7 C4,6.48716416 4.38604019,6.06449284 4.88337887,6.00672773 L5,6 L10,6 C10,3.790861 11.790861,2 14,2 Z M17.7309061,19.0241379 L17.0237993,19.7312446 L18.7933527,21.5006913 L17.0263884,23.2674911 C16.8504114,23.5072486 16.8504114,23.7348403 17.0263884,23.9745978 C17.2661459,24.1505748 17.4937377,24.1505748 17.7334952,23.9745978 L19.5003527,22.2076913 L21.2693951,23.9768405 C21.5091526,24.1528175 21.7367444,24.1528175 21.9765019,23.9768405 C22.1524789,23.737083 22.1524789,23.5094912 21.9765019,23.2697337 L20.2073527,21.5006913 L21.9792686,19.7312918 C22.1552456,19.4915343 22.1552456,19.2639425 21.9792686,19.024185 C21.7395111,18.848208 21.5119194,18.848208 21.2721619,19.024185 L19.5003527,20.7936913 L17.7309061,19.0241379 Z M14,4 C12.9456382,4 12.0818349,4.81587779 12.0054857,5.85073766 L12,6 L16,6 C15.9181651,4.81587779 15.0543618,4 14,4 Z"
              fill="#A9A9A9"
            />
          </svg>
        </div>

        <h2>Are you sure you want to delete this appointment?</h2>
        <p>All data related to this appointment will be lost</p>

        <div className="delete-modal-actions">
          <button
            className="confirm-btn"
            onClick={onConfirm}
            disabled={isDeleting}
          >
            {isDeleting ? "Deleting..." : "Delete"}
          </button>

          <button
            className="cancel-btn"
            onClick={onClose}
            disabled={isDeleting}
          >
            Cancel
          </button>
        </div>

      </div>
    </div>
  );
}